/**
 * Backward-compatibility shims for legacy global APIs expected by older bundles or plugins.
 *
 * Provides a minimal DG.getSystemStatus() implementation to prevent
 * "DG.getSystemStatus is not a function" runtime errors in legacy code paths.
 */

import axios from 'axios';

(function setupDGShim() {
  if (typeof window === 'undefined') return;

  // Ensure DG namespace exists
  const DG = (window.DG = window.DG || {});

  // Only define if not already provided
  if (typeof DG.getSystemStatus !== 'function') {
    DG.getSystemStatus = async function getSystemStatus() {
      try {
        // Prefer the authenticated health endpoint used by SystemMonitoring
        const res = await axios.get('/api/system/status');
        return res.data;
      } catch (err) {
        // Graceful fallback for callers expecting a promise rejection
        // and to aid debugging if this path is unexpectedly hit
        // eslint-disable-next-line no-console
        console.warn('[compatShims] DG.getSystemStatus failed:', err?.message || err);
        throw err;
      }
    };

    // eslint-disable-next-line no-console
    console.info('[compatShims] Installed DG.getSystemStatus shim for legacy compatibility');
  }
})();
